module.exports = __webpack_public_path__ + "img/geosat-logo.7c5cbf57.png";